import { gql } from "lib/apolloClient";
import { genericFolderFragment } from "modules/CommonFragments";

/* DEPRECATED ( REASON: FOR BETTER ERROR HANDLING ON BACKEND, USED PLATFORM MUTATION )
export const createFolderMutation = gql`
  mutation createFolder($courseId: ID!, $name: String!, $color: String) {
    documentation {
      createFolder(input: { course: $courseId, name: $name, color: $color }) {
        id
        name
      }
    }
  }
`;

export const updateFolderMutation = gql`
  mutation updateFolder(
    $id: ID!
    $courseId: ID
    $name: String
    $color: String
  ) {
    documentation {
      updateFolder(
        input: { id: $id, course: $courseId, name: $name, color: $color }
      ) {
        id
        name
        color
      }
    }
  }
`;*/

export const createFolderMutationV2 = gql`
  mutation createFolder(
    $courseId: ID!
    $name: String!
    $color: String
    $type: FOLDER_TYPE_ENUM!
  ) {
    platform {
      createFolder(
        input: { courseId: $courseId, name: $name, color: $color, type: $type }
      ) {
        warning
        response {
          ...genericFolderItem
        }
      }
    }
  }
  ${genericFolderFragment.genericFolderBasicDetails}
`;

export const updateFolderMutationV2 = gql`
  mutation updateFolder(
    $id: ID!
    $name: String
    $color: String
    $type: FOLDER_TYPE_ENUM!
  ) {
    platform {
      updateFolder(
        input: { id: $id, name: $name, color: $color, type: $type }
      ) {
        warning
        response {
          ...genericFolderItem
        }
      }
    }
  }
  ${genericFolderFragment.genericFolderBasicDetails}
`;

export const deleteFolderMutation = gql`
  mutation deleteFolder($id: ID!) {
    documentation {
      deleteFolder(input: { id: $id })
    }
  }
`;
